import { useEffect } from "react";

import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";

import { DoitConsoleTitle } from "../../Components/DoitConsoleTitle";
import mixpanel from "../../utils/mixpanel";
import NewHome from "./NewHome/NewHome";

export const HomePage = () => {
  useEffect(() => {
    mixpanel.track(`home.page.view`);
  }, []);

  return (
    <Container maxWidth="xl" sx={{ pb: 8, mt: 4 }}>
      <DoitConsoleTitle pageName="Home" />
      <Stack
        sx={{
          rowGap: 6,
        }}
      >
        <NewHome />
      </Stack>
    </Container>
  );
};
